import React from 'react';
import '../Options.css';

const ShortAnswerResult = ({ answer }) => {
    if (!answer || !answer.answers) {
        console.error("ShortAnswerResult expected 'answer' with 'answers' property but received:", answer);
        return <div>Данные отсутствуют</div>;
    }
    // console.log(answer)

    return (
        <div className='shortAnswer__wrapResult' style={{ width: '100%' }}>
            <div className='shortAnswer__wrap_input'>
                <div style={{marginTop: '13px'}} className='shortAnswer__subtitle'>Ваш ответ</div>
                <div style={{width: '60%'}}>
                    <div className={answer.is_correct > 0 ? 'shortAnswer__answer_true' : 'shortAnswer__answer_false'}></div>
                    <div className='shortAnswer__inputResult' style={{ border: answer.is_correct ? '1px solid #22C532' : '1px solid #FF0000' }}>
                        {typeof answer.answers === 'string' ? answer.answers : answer.answers.text}
                    </div>
                </div>
            </div>
            <div className='shortAnswer__commentResult' style={{ display: 'flex', fontWeight: 700, gap: '5px', color: answer.is_correct ? '#22C532' : '#FF0000' , fontSize: '16px', marginLeft: '16px' }}>
                <div style={{ fontWeight: 400, fontSize: '16px', color: '#000000'}}>Результат:</div>
                {answer.is_correct ? 'Верно' : 'Неверно'}
            </div>
            {answer.answer_comment && (
                <div style={{ display: 'flex', gap: '5px' }}>
                    <div style={{ fontWeight: 600 }}>Комментарий:</div> {answer.answer_comment}
                </div>
            )}
        </div>
    );
};

export default ShortAnswerResult;